import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full py-6 mx-auto" }
const _hoisted_2 = { class: "flex items-center mt-5 mb-6 space-x-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Search", -1)
const _hoisted_4 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "text-sm" }
const _hoisted_8 = { class: "px-6 py-6 text-sm text-center text-gray-900 whitespace-nowrap" }
const _hoisted_9 = { class: "px-6 py-6 text-sm text-center text-gray-900 whitespace-nowrap" }
const _hoisted_10 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_11 = { class: "flex items-center justify-center mx-auto" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "View Record", -1)
const _hoisted_14 = { class: "w-full px-6 border-t py-7" }

import { ref, computed, watch, onMounted } from "vue";
import UserLayout from "@/layouts/UserLayout.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import SectionTitle from "@/components/partials/SectionTitle.vue";
import DataTable from "@/components/partials/DataTable.vue";
import MinifyPagination from "@/components/partials/MinifyPagination.vue";
import PatientService from "@/classes/PatientService";
import pickBy from "lodash/pickBy";
import Storage from "@/helpers/storage";
import { useRouter, useRoute } from "vue-router";
import { PatientSearch } from "@/interfaces/PatientInterface";
import { useNetworkStore } from "@/store/network";
import DateFormatter from "@/helpers/DateFormatter";
import InterventionService from "@/classes/Interventions/InterventionService"
import SearchIcon from "@/components/icons/searchIcon.vue";
import PaperIcon from "@/components/icons/paperIcon.vue";
import PageLoader from "@/components/loaders/PageLoader.vue";

interface itemsInterface {
	id: number;
	name: string | null;
	birthdate_formatted: string | null;
	registered_at_formatted: string | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const networkStore = useNetworkStore();

const isNetworkAvailable = computed<boolean>(():boolean => networkStore.isNetworkAvailable);

const headers: { text: string; haveSort?: boolean }[] = [
	{ text: "Patient Name", haveSort: true },
	{ text: "Birthday" },
	{ text: "Date Registered", haveSort: true },
];

const router = useRouter();
const route = useRoute();
const storage = new Storage();

const loading = ref<boolean>(false);
const items = ref<itemsInterface[]>([]);
const page = ref<string | null>(route.query.page);
const lastPage = ref<number | null>(null);
const rows = ref<number | null>(route.query.rows || 5);
const numRows = computed<string | null>(() => (rows.value ? rows.value + " Rows" : "All"));
const search = ref<PatientSearch>({
	last_name: route.query.last_name,
	first_name: route.query.birthdate,
	birthdate: route.query.first_name,
	mode: 'patient',
});

const getData = () => {
    loading.value = true;
	InterventionService
		.patientSearch(
			{ 
				...search.value,
				...{ page: page.value, rows: rows.value } 
			}, 
			isNetworkAvailable.value
		)
		.then((response: any) => {
            items.value = response.data.items.data;
			page.value = response.data.items.current_page;
			lastPage.value = response.data.items.last_page;
			storage.set("search", JSON.stringify(search.value));
            loading.value = false;
		})
		.catch((error) => {
            loading.value = false;
			console.log(error);
		});
};

const reloadPage = async () => {
	return await router.push({
		path: "/intervention/index",
		query: pickBy({ ...search.value, ...{ page: page.value, rows: rows.value } }),
	});
};

const applyFilters = () => {
	reloadPage().then(() => {
		getData();
	});
};

const paginate = (data: number): void => {
	page.value = data;
	applyFilters();
};

const changeRows = (row: any): void => {
	rows.value = row;
	applyFilters();
};

const getSearchFromStorage = (): void => {
	const searchData = JSON.parse(storage.get("search"));
	search.value.last_name = searchData ? searchData.last_name : search.value.last_name;
	search.value.first_name = searchData ? searchData.first_name : search.value.first_name;
	search.value.birthdate = searchData ? searchData.birthdate : search.value.birthdate;
};

onMounted(() => {
	Promise.allSettled([getSearchFromStorage()]).then(() => {
		applyFilters();
	});
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(SectionTitle, {
          title: "Intervention: Patient",
          description: "View the data analytics in the system."
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).replace(`/intervention/search`)))
          }, [
            _createVNode(ButtonComponent, { customClass: "quaternary md:w-auto w-full" }, {
              default: _withCtx(() => [
                _createVNode(SearchIcon, { class: "object-contain w-4 h-4 mr-1 -ml-2 icon" }),
                _hoisted_3
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(DataTable, {
            headers: headers,
            "no-action": false,
            count: items.value?.length,
            tableClass: "header-frm-table two three"
          }, {
            body: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
                return (_openBlock(), _createElementBlock("tr", { key: item }, [
                  _createElementVNode("td", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("img", {
                        class: "object-cover w-6 h-6 mr-2 text-center rounded-full",
                        src: item.profile_photo_url
                      }, null, 8, _hoisted_6),
                      _createElementVNode("span", _hoisted_7, _toDisplayString(item.first_name) + " " + _toDisplayString(item.last_name), 1)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_8, _toDisplayString(item?.birthdate ? _unref(DateFormatter).customDateFormat(item?.birthdate, 'MM/dd/yyy') : item.computed_age), 1),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(_unref(DateFormatter).customDateFormat(item.registered_at, 'MM/dd/yyy - hh:mm:ss')), 1),
                  _createElementVNode("td", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("a", {
                        onClick: ($event: any) => (_unref(router).replace(`/intervention/${item.patient_id}/view`))
                      }, [
                        _createVNode(ButtonComponent, { customClass: "primary w-max" }, {
                          default: _withCtx(() => [
                            _createVNode(PaperIcon, { class: "w-4 h-4 mr-1 -ml-2 icon" }),
                            _hoisted_13
                          ]),
                          _: 1
                        })
                      ], 8, _hoisted_12)
                    ])
                  ])
                ]))
              }), 128))
            ]),
            tfoot: _withCtx(() => [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(MinifyPagination, {
                  numRows: numRows.value,
                  "onUpdate:rows": _cache[1] || (_cache[1] = (value) => changeRows(value)),
                  "onUpdate:page": _cache[2] || (_cache[2] = (value) => paginate(value)),
                  "current-page": page.value,
                  "last-page": lastPage.value
                }, null, 8, ["numRows", "current-page", "last-page"])
              ])
            ]),
            _: 1
          }, 8, ["count"])
        ])
      ]),
      _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})